<template>
    <div class="flex-xs-12 flex-sm-4 flex-lg-4">
        <div class="discount-frame">
            <div class="discount-cta-title text-center">
                {{ featuredDiscount.description }}
            </div>
            <div class="discount-cta-subtitle text-center">{{ value }}</div>
            <div class="px">
                <DiscountButton
                    :featured-discount="featuredDiscount"
                    class="mx-auto my"
                    @reveal="$emit('reveal', featuredDiscount)"
                />
            </div>
            <div class="aspect aspect-xs-1-1">
                <img
                    :data-src="`${$scope.CDN_IMAGES}/images/site/cupom-de-desconto/${featuredDiscount.image}?w=500`"
                    class="lazy lazy-fade img-responsive"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import DiscountButton from './DiscountButton';
    import { updateLazyLoad } from '../../../common/common';
    import FeaturedDiscount from './FeaturedDiscount';

    export default {
        name: 'DiscountFrame',

        mixins: [FeaturedDiscount],

        components: { DiscountButton },

        mounted() {
            updateLazyLoad();
        },
    };
</script>
